import { Component } from '@angular/core';

@Component({
    selector: 'app-help',
    templateUrl: './help.component.html',
    styleUrl: './help.component.css',
    standalone: false
})
export class HelpComponent {

}
